import { jsx as s, jsxs as V } from "react/jsx-runtime";
import { useWatch as C, UnprocessableContentError as W } from "@systemeio/util";
import { ContactSlugEnum as a } from "@systemeio/ui";
import { useState as m } from "react";
import _ from "../../components/card-wrapper.mjs";
import z from "../../components/field.mjs";
import N from "../../components/item-thumbnail-base.mjs";
import P from "../../ui-kit/theme-button.mjs";
import { getDefaultFieldValues as d } from "../../utils/get-default-field-values.mjs";
import { handleOptin as U } from "./api/index.mjs";
import { useVisitorInfoStore as Z } from "../../store/index.mjs";
import { StoreImageEnum as $ } from "../../enums/store-image-enum.mjs";
const Y = ({
  id: i,
  title: O,
  subTitle: x,
  thumbnail: E,
  fields: u,
  buttonTitle: F,
  thankYouPage: c,
  headingLevel: I
}) => {
  const [S, l] = m(!1), [p, f] = m({}), [r, n] = m(
    d(u)
  ), { visitorInfo: j } = Z();
  C(u, (t) => n(d(t))), C(j, (t) => {
    if (!t) return;
    const e = r[a.Country], o = Object.prototype.hasOwnProperty.call(r, a.Country) && !(e != null && e.value);
    t.country && o && e && n({
      ...r,
      [a.Country]: {
        ...e,
        value: t.country
      }
    });
  });
  const T = async () => {
    var e;
    if (!i) return;
    const t = Object.values(r).map((o) => ({
      slug: o.slug,
      value: o.value ?? ""
    }));
    try {
      f({}), l(!0);
      const o = Intl.DateTimeFormat().resolvedOptions().timeZone;
      await U({
        itemOptIn: `/api/dashboard/digital-store/item-opt-ins/${i}`,
        values: t,
        timezone: o
      }), c.path && window.location.assign(c.path);
    } catch (o) {
      o instanceof W && ((e = o.errors.violations) == null || e.forEach((h) => {
        var y;
        const w = /values\[(\d+)]/, g = h.propertyPath.match(w);
        if (g) {
          const D = parseInt(g[1]), b = (y = t.find((v, B) => B === D)) == null ? void 0 : y.slug;
          b && f((v) => ({ ...v, [b]: h.message }));
        }
      }));
    } finally {
      l(!1);
    }
  };
  return /* @__PURE__ */ s(_, { children: /* @__PURE__ */ V(
    "form",
    {
      onSubmit: (t) => {
        t.preventDefault(), T();
      },
      className: "flex flex-col gap-3",
      children: [
        /* @__PURE__ */ s(
          N,
          {
            title: O,
            subTitle: x,
            imageType: $.optin_thumbnail,
            thumbnail: E,
            headingLevel: I
          }
        ),
        Object.values(r).map((t) => {
          const e = (o) => n({
            ...r,
            [t.slug]: { ...t, value: o }
          });
          return /* @__PURE__ */ s(
            z,
            {
              contactFields: r,
              field: t,
              value: t.value,
              error: p[t.slug] ? [p[t.slug] ?? ""] : [],
              onChange: e
            },
            t.slug
          );
        }),
        /* @__PURE__ */ s(P, { isFetching: S, type: "submit", children: F })
      ]
    }
  ) });
};
export {
  Y as default
};
